import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog dialog--info" }
const _hoisted_2 = { class: "dialog__body" }
const _hoisted_3 = { class: "xhtml" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "details-container" }
const _hoisted_7 = { class: "route" }
const _hoisted_8 = { class: "direction" }
const _hoisted_9 = { class: "departure" }
const _hoisted_10 = { class: "payment" }
const _hoisted_11 = { class: "price" }
const _hoisted_12 = { class: "price fee" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "price" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "confirm" }
const _hoisted_17 = { class: "terms" }
const _hoisted_18 = {
  key: 0,
  class: "dialog__spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "slide",
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dialog-overlay",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.overlayClicked($event)), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "dialog__close",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.overlayClicked($event)), ["self"]))
                  }),
                  _createElementVNode("header", null, _toDisplayString(_ctx.title) + " " + _toDisplayString(_ctx.data.booking.bookingNumber), 1),
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.data.type === _ctx.AmendmentOptionTypeEnum.CancelBooking)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " You are about to cancel your journey. The amount will be automatically refunded to the means of payment that was used when the booking was purchased. "))
                      : (_openBlock(), _createElementBlock("p", _hoisted_5, " You are about to cancel part of your journey. The amount will be automatically refunded to the means of payment that was used when the booking was purchased. "))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("ul", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.booking.bookingSections, (section, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "title"
                        }, [
                          _createElementVNode("div", _hoisted_8, [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_BaseSvg, { icon: 'arrow/arrow-right' }),
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("departure.outward")), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_component_BaseSvg, { icon: 'arrow/arrow-left' }),
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("departure.return")), 1)
                                ], 64))
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["text", { delete: _ctx.departureToDelete(section.route) }])
                            }, _toDisplayString(section.routeText) + ", " + _toDisplayString(_ctx.YYYYMMDD(section.departureDate)) + " " + _toDisplayString(_ctx.HHmm(section.departureDate)), 3)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("ul", _hoisted_10, [
                      _createElementVNode("li", _hoisted_11, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label" }, "Total:", -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.data.booking.currency) + " " + _toDisplayString(_ctx.data.payment.paid.toFixed(2)), 1)
                      ]),
                      _createElementVNode("li", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("account.bookings.cancel.payment.cancellationFee")) + ":", 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.data.booking.currency) + " " + _toDisplayString(_ctx.data.payment.cancellationFee.toFixed(2)), 1)
                      ]),
                      _createElementVNode("li", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("account.bookings.cancel.payment.refund")) + ":", 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.data.booking.currency) + " " + _toDisplayString(_ctx.data.payment.refund.toFixed(2)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("account.bookings.cancel.payment.confirm")), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_BaseCheckbox, {
                        id: 'terms',
                        name: 'terms',
                        label: 'I accept the terms of change and cancellation',
                        modelValue: _ctx.v$.termsAccepted.$model,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.termsAccepted.$model) = $event)),
                        hasError: _ctx.v$.termsAccepted.$error,
                        errors: _ctx.v$.termsAccepted.$errors,
                        valid: !_ctx.v$.termsAccepted.$invalid
                      }, null, 8, ["modelValue", "hasError", "errors", "valid"])
                    ])
                  ]),
                  _createElementVNode("footer", null, [
                    _createVNode(_component_BaseButton, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = false)),
                      class: _normalizeClass('button--white')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("button.cancel")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_BaseButton, {
                      class: "button--danger",
                      onClick: _withModifiers(_ctx.submit, ["stop"]),
                      loading: _ctx.loading,
                      disabled: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("account.bookings.cancel.payment.confirm")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading", "disabled"])
                  ])
                ]),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_BaseSpinner, { size: 50 })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}